<div class="drill-down-sticky-financials">
  <p-table [value]="items" [columns]="headerRows" styleClass="financial-category-table" [scrollable]="true" frozenWidth="290px">
    <ng-template pTemplate="header" let-headerRows>
      <tr *ngFor="let row of headerRows; let rowIndex = index" class="financial-category-header-row">
        <ng-container *ngIf="rowIndex === 0">
          <th pFrozenColumn>Financial</th>
        </ng-container>
        <ng-container *ngIf="rowIndex === 1 && isNonBvd">
          <th pFrozenColumn>Database</th>
        </ng-container>
        <ng-container *ngIf="rowIndex === 0 || (rowIndex === 1 && isNonBvd)">
          <th [style.width]="'250px'" *ngFor="let col of row.cols; let i = index" [attr.colspan]="!col.colspan ? 1 : col.colspan">
            {{ col.label }}
          </th>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data let-headerRows="columns">
      <tr class="financial-category-row">
        <td [ngClass]="{ 'static-financial-row': noParent(data), 'financial-sub-category-indent': isChild(data) }" pFrozenColumn>
          {{ data['vendorAccountName'] }}
        </td>
        <td [style.width]="'250px'" *ngFor="let col of headerRows[1].cols; let i = index" [ngClass]="{ 'static-financial-row-data': noParent(data) }">
          {{
            data[col.field] === null || data[col.field] === undefined
              ? 'N.A.'
              : !noParent(data) && isNum(data[col.field])
              ? (data[col.field] | number)
              : data[col.field]
          }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer" let-columns>
      <tr class="financial-category-footer-row">
        <td [attr.colspan]="columns[1].cols.length"></td>
      </tr>
    </ng-template>
  </p-table>
</div>
